import {
  GET_INSURER_PAYOUT_DETAIL,
  GET_PAYOUT_INSURER_COUNT,
  GET_TOTAL_BILLING,
  GET_TOTAL_CLIENT_DATA,
  GET_INSURER_APPOOINTMENT_DETAIL,
  GET_STATUS_QUEUE_DATA,
  INS_REMARKS
} from "../../Utils/types";

const initialState = {
  getInsurerPayoutCount: null,
  getInsurerPayoutDetail: null,
  getTotalBilling: null,
  getTotalClientData: null,
  getInsAppointmentDetail:null,
  getStatusQueueData:null,
  insRemarks:null
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_PAYOUT_INSURER_COUNT:
      return {
        ...state,
        getInsurerPayoutCount: action.payload,
      };
    case GET_INSURER_PAYOUT_DETAIL:
      return {
        ...state,
        getInsurerPayoutDetail: action.payload,
      };
    case GET_TOTAL_BILLING:
      return {
        ...state,
        getTotalBilling: action.payload,
      };
    case GET_TOTAL_CLIENT_DATA:
      return {
        ...state,
        getTotalClientData: action.payload,
      };
    case GET_INSURER_APPOOINTMENT_DETAIL:
      return {
        ...state,
        getInsAppointmentDetail: action.payload,
      };
    case GET_STATUS_QUEUE_DATA:
      return {
        ...state,
        getStatusQueueData: action.payload,
      };
    case INS_REMARKS:
      return {
        ...state,
        insRemarks: action.payload,
      };
    default:
      return state;
  }
};
